export default __webpack_public_path__ + "static/11(1)-08a314060d1f6f76b9f3df6816eb5ee3.png";